import { render, staticRenderFns } from "./ClubGoodsList.vue?vue&type=template&id=825324d2&scoped=true&"
import script from "./ClubGoodsList.vue?vue&type=script&lang=js&"
export * from "./ClubGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./ClubGoodsList.vue?vue&type=style&index=0&id=825324d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825324d2",
  null
  
)

export default component.exports